import { Job } from '@cibli/shared';
import { useState } from 'react';

export const useJobSelection = () => {
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const [isClosing, setIsClosing] = useState(false);

  const selectJob = (job: Job) => {
    if (selectedJob?.id === job.id) {
      setIsClosing(true);
      setTimeout(() => {
        setSelectedJob(null);
        setIsClosing(false);
      }, 300);
    } else {
      setSelectedJob(job);
    }
  };

  const clearSelection = () => {
    setIsClosing(true);
    setTimeout(() => {
      setSelectedJob(null);
      setIsClosing(false);
    }, 300);
  };

  return {
    selectedJob,
    isClosing,
    selectJob,
    clearSelection,
  };
};
